import { Link } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import UserMenu from "@/components/UserMenu";
import ThemeToggle from "@/components/ThemeToggle";
import { isStaging } from "@/lib/env";

export default function AppHeader() {
  const { user } = useAuth();
  return (
    <>
      {isStaging() && (
        <div
          role="status"
          style={{
            background: "#f58231",
            color: "#fff",
            textAlign: "center",
            padding: "4px 8px",
            fontSize: "0.75rem",
            fontWeight: 700,
            letterSpacing: "0.12em",
          }}
        >
          STAGING — not the live site
        </div>
      )}
      <header className="app-header">
        <Link to="/landing" className="brand-mark">
          TapVocab
        </Link>
        <div className="app-header-actions">
          {user?.isAdmin && (
            <Link to="/admin" className="admin-pill">
              Admin
            </Link>
          )}
          <ThemeToggle />
          <UserMenu />
        </div>
      </header>
    </>
  );
}
